import { container } from 'tsyringe';
import { ModelManager } from '@/prototyping/model';
import { JsonRpcModule, JsonRpcNotifyHandler, JsonRpcCallHandler } from '../../jrpc/module';

export class CoreModule extends JsonRpcModule {
    @JsonRpcNotifyHandler("sayHello")
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onSayHello(): void { }

    @JsonRpcCallHandler("add")
    onAdd(a: number, b: number): number {
        return a + b;
    }
    
    @JsonRpcCallHandler("getSerializedAppState")
    getSerializedAppState(): string {
        return container.resolve(ModelManager).serialize();
    }

    @JsonRpcCallHandler("saveSerializedAppState")
    saveSerializedAppState(): void {
        const state = container.resolve(ModelManager).serialize();
        localStorage.setItem("serializedAppState", state);
        console.log(localStorage.getItem("serializedAppState"));
    }

    @JsonRpcCallHandler("getWindow")
    getWindow() : {scrollX: number; scrollY: number;} {
        const context = {
            scrollX: window.pageXOffset || window.scrollX,
            scrollY: window.pageYOffset || window.scrollY,
        }

        return context;
    }

    @JsonRpcCallHandler("getElement")
    getElement(xpath: string): {scrollLeft: number; scrollTop: number; boundingClientRect: DOMRect;} | null  {
        const node = document.evaluate(xpath, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;

        if (!node) {
            return null;
        }

        const element = node as Element;
        const boundingClientRect = element.getBoundingClientRect();

        const context = {
            scrollLeft: element.scrollLeft,
            scrollTop: element.scrollTop,
            boundingClientRect
        }

        return context;
    }

}
